import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { IconFontType } from '../icon-font/icon-font-type.enum';
import { LocService } from '../shared-context/loc.service';

import './text-filter.component.css';

const debounceTimeDelay = 150;

/**
  * A Component that will be used to filter the list.
  */
@Component({
    selector: 'ohp-text-filter',
    templateUrl: './text-filter.component.html'
})
export class TextFilterComponent implements OnInit, OnDestroy {
    @ViewChild('tabListFilterInputText') public tabListFilterInputTextElement: ElementRef;
    @Output() public readonly filterInput: EventEmitter<string> = new EventEmitter<string>();

    public filterIcon = IconFontType.Filter;
    public filterInputButtonAriaLabel: string;
    public filterPlaceholderText: string;
    public filterSearchAriaLabel: string;
    public filterText: string = undefined;

    private readonly filterInputChanged = new Subject<string>();
    private filterInputSubscription: Subscription;

    constructor(private readonly locService: LocService) {

    }

    public ngOnInit(): void {
        this.filterInputButtonAriaLabel = this.locService.EdgeworthFilterPlaceholderText;
        this.filterPlaceholderText = this.locService.EdgeworthFilterPlaceholderText;
        this.filterSearchAriaLabel = this.locService.EdgeworthFilterSearchAriaLabel;
        this.filterInputSubscription = this.filterInputChanged
            .pipe(debounceTime(debounceTimeDelay))
            .subscribe(inputText => this.onFilter(inputText));
    }

    public ngOnDestroy(): void {
        this.filterInputSubscription.unsubscribe();
    }

    public onClearTextFilter() {
        this.filterText = '';
        this.tabListFilterInputTextElement.nativeElement.value = '';
        this.filterIcon = IconFontType.Filter;
        this.filterInputButtonAriaLabel = this.locService.EdgeworthClearTextAriaLabel;
        this.filterInput.emit(this.filterText);
        this.tabListFilterInputTextElement.nativeElement.focus();
    }

    public onInputChange(event) {
        this.filterInputChanged.next(event.target.value);
    }

    private onFilter(filterText: string) {
        this.filterText = filterText;
        if (this.filterText) {
            this.filterIcon = IconFontType.X;
            this.filterInputButtonAriaLabel = this.locService.EdgeworthClearTextAriaLabel;
        } else {
            this.filterIcon = IconFontType.Filter;
            this.filterInputButtonAriaLabel = this.locService.EdgeworthFilterPlaceholderText;
        }
        this.filterInput.emit(this.filterText);
    }
}
